var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMTorse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 178,
    viewBox: "0 0 116 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9592 20.0371C6.97045 38.327 15.1379 91.2108 15.6394 104.411C17.2694 140.809 15.6823 165.72 13.762 177.009",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51562 0.00878906C9.51562 0.00878906 10.0476 29.2933 15.5723 38.1899",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1138 59.903C8.02957 55.7029 0.499975 26.7403 0.499975 7.23584",
    stroke: "#909090",
    strokeMiterlimit: 4.28677,
    strokeLinecap: "square",
    strokeDasharray: "4 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.792 20.0371C108.781 38.327 100.613 91.2108 100.112 104.411C98.4816 140.809 100.069 165.72 101.989 177.009",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.235 0.00878906C106.235 0.00878906 105.703 29.2933 100.178 38.1899",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.637 59.903C107.721 55.7029 115.251 26.7403 115.251 7.23584",
    stroke: "#909090",
    strokeMiterlimit: 4.28677,
    strokeLinecap: "square",
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMTorse1);
export default __webpack_public_path__ + "static/media/M-TORSE_1.d5112e17ff4a95377d156b7f296d62d2.svg";
export { ForwardRef as ReactComponent };